import { render, staticRenderFns } from "./v-gridform.vue?vue&type=template&id=a8e35f06&scoped=true&"
import script from "./v-gridform.vue?vue&type=script&lang=js&"
export * from "./v-gridform.vue?vue&type=script&lang=js&"
import style0 from "./v-gridform.vue?vue&type=style&index=0&id=a8e35f06&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a8e35f06",
  null
  
)

export default component.exports